module.exports = __webpack_public_path__ + "static/media/truck-icon-running.f5ad60b4.svg";